import "../styles/main.scss"

import SiteHeader from "./modules/site-header"
import SiteNavMobile from "./modules/site-nav-mobile"
import SmoothAnchor from "./modules/smooth-anchor";
import MC from "./plugins/mc"
import Animation from "./modules/animation";
import AnimationMagnetic from "./modules/animation-magnetic";
import AnimationFooter from "./modules/animation-footer";
import ReadMore from "./modules/read-more";
import AnimationPage from "./modules/animation-page"
// import AOS from 'aos';

// AOS.init({
//     offset: 100,
//     duration: 600,
//     delay: 100,
//     once: true,
//     // disable: function() {
//         // return window.innerWidth < 1024;
//     // }
// });

SmoothAnchor().init()
SiteHeader().init()
SiteNavMobile().init()
MC().init()
Animation().init()
AnimationMagnetic().init()
AnimationFooter().init()
ReadMore().init()
// AnimationPage().init()